import React, { useContext, useRef, useState } from "react";
import emailjs from "emailjs-com";
import { EmailContext } from "../components/context/email-context";

const ExtraHelpForm = () => {
  const fileInput = useRef(null);
  const [filename, setFilename] = useState("Nessun file selezionato");
  const [formStatus, setFormStatus] = useState("ready");

  const { email, setEmail } = useContext(EmailContext);
  const [tempEmail, setTempEmail] = useState(email);

  const submitForm = async (e) => {
    e.preventDefault();
    setFormStatus("sending");
    setEmail(tempEmail);

    const data = new FormData(e.target);
    const acIntegration = fetch(
      "https://calchitaliani.activehosted.com/proc.php",
      {
        method: "POST",
        body: data,
        mode: "no-cors",
      }
    );

    const sendMail = emailjs.sendForm(
      process.env.GATSBY_EMAILJS_SERVICE,
      process.env.GATSBY_EMAILJS_TEMPLATE,
      "#assistenza-form",
      process.env.GATSBY_EMAILJS_USER
    );

    try {
      await Promise.all([acIntegration, sendMail]);
      setFormStatus("sent");
    } catch (e) {
      console.log("Error:");
      console.log(e);
      setFormStatus("error");
    }
  };

  return (
    <div className="mt-32 flex gap-8 mb-32">
      <div className="flex-1">
        <p className="ci-sottotitolo">Assistenza</p>
        <h2 className="ci-h2 mt-3.5">Hai ancora bisogno di Aiuto?</h2>
        <p className="mt-6">
          Se non hai trovato risposta alle tue domande, puoi scriverci,
          chiamarci oppure puoi compilare il form qui di fianco e ti
          risponderemo in tempi brevi.
        </p>
      </div>
      <p>{formStatus}</p>
      <form className="flex-1" onSubmit={submitForm} id="assistenza-form">
        <input type="hidden" name="u" value="3" />
        <input type="hidden" name="f" value="3" />
        <input type="hidden" name="s" />
        <input type="hidden" name="c" value="0" />
        <input type="hidden" name="m" value="0" />
        <input type="hidden" name="act" value="sub" />
        <input type="hidden" name="v" value="2" />
        <input
          type="text"
          name="fullname"
          required
          placeholder="Nome"
          className="ci-input mt-10"
        />
        <input
          type="email"
          name="email"
          required
          placeholder="Email"
          className="ci-input mt-4"
          value={tempEmail}
          onChange={(e) => {
            setTempEmail(e.target.value);
          }}
        />
        <input
          type="text"
          name="phone"
          placeholder="Telefono (facoltativo)"
          className="ci-input mt-4"
        />
        <input
          type="text"
          name="numero_ordine"
          placeholder="Numero d'ordine (se disponibile)"
          className="ci-input mt-4"
        />
        <select name="field[2]" className="hidden">
          <option></option>
          <option selected value="IT">
            IT
          </option>
          <option value="EN">EN</option>
          <option value="ES">ES</option>
        </select>
        <textarea
          placeholder="Descrivi il problema"
          name="message"
          className="ci-input h-24 mt-4 resize-none"
          style={{ borderRadius: "26px" }}
        />

        {/* <label className="ci-input mt-4 relative inline-block pl-40 text-ci-gray cursor-pointer">
          <div className="absolute left-0 top-0 h-full flex items-center rounded-full bg-ci-green text-white justify-center font-bold w-36">
            Allega file
          </div>
          {filename}
          <input
            type="file"
            ref={fileInput}
            className="absolute w-px h-px"
            style={{ left: "-99999px" }}
            onChange={() => {
              const files = fileInput?.current?.files ?? [];
              setFilename(
                files.length > 0 ? files[0].name : "Nessun file selezionato"
              );
            }}
          />
        </label> */}
        <label className="mt-4 flex items-center gap-1 cursor-pointer">
          <input type="checkbox" required />
          <p className="text-xs">
            Accetto i Termini e la Privacy Policy di Calchi Italiani.
          </p>
        </label>

        <button className="ci-button mt-5 uppercase">Invia Richiesta</button>
      </form>
    </div>
  );
};

export default ExtraHelpForm;
